export default __webpack_public_path__ + "static/media/Modulo_monitoreo.7b9cc0f7.png";